/**
 * Brand constants for user-visible product references
 */
export const brand = {
  name: "SerenitAI"
} as const;
